import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { cancelMembershipSubscription } from '../../../../../Redux/Actions/EndUser/AccountDetailsActions';

class AutoRenew extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
      autoRenewInEdit: {
        isAutoRenew: true
      }
		};
  }

  handleInputChange = (event) => {
    let target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    const edited = this.state.autoRenewInEdit;
    edited[name] = value;
    this.setState({
      autoRenewInEdit: edited
    });
  };

  handleSubmit = (event) => {
		event.preventDefault();
    this.props.cancelMembershipSubscription({
      membershipId: this.props.membershipId
    });
	}

  render() {
    return (
      <div className="subscription-details">
        <form onSubmit={this.handleSubmit} className="auto-renew">
          <div className="list-group-item form-group">
              <div className="custom-control custom-checkbox">
                <input
                  name="isAutoRenew"
                  id="isAutoRenew"
                  type="checkbox"
                  className="custom-control-input"
                  checked={this.state.autoRenewInEdit.isAutoRenew}
                  onChange={this.handleInputChange}
                />
                  <label className="custom-control-label" htmlFor="isAutoRenew">Auto-Renew Membership</label>
              </div>
            </div>
            <div className="list-group-item">
              <button
                className="btnPrimary btn btn-primary"
                name="save"
                type="submit"
                disabled={this.state.autoRenewInEdit.isAutoRenew}
              >SAVE</button>
            </div>
        </form>
      </div>
    );
  }
}

export default withRouter(
	connect(null, {
    cancelMembershipSubscription
	})(AutoRenew)
);
